import type * as ecModels from '../../../models'

import type * as models from './models'

export type Config<TTypeParams extends ecModels.TypeParams.Constraint> =
  Required<Config.Options<TTypeParams>>
export namespace Config {
  export function from<TTypeParams extends ecModels.TypeParams.Constraint>(
    config?: Config.Options<TTypeParams>,
  ): Config<TTypeParams> {
    return {
      initialGroups: config?.initialGroups ?? [],
    }
  }

  export interface Options<TTypeParams extends ecModels.TypeParams.Constraint> {
    initialGroups?: readonly models.Group<TTypeParams>[]
  }
}
